import { gql } from '@apollo/client';

export const CREATE_EXPOSURE_TRIP = gql`
    mutation CreateExposureTrip($supportedOrganisationId: Int!, $name: String, $date: String, $location: String, $durationDays: Int, $description: String) {
        createExposureTrip(supportedOrganisationId: $supportedOrganisationId, name: $name, date: $date, location: $location, durationDays: $durationDays, description: $description) {
            id
            name
            date
            location
            durationDays
            description
        }
    }
`;
